import { ActivatedRouteSnapshot, Router, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable } from "rxjs";
import { AdministratorsService, OrganiserUsersService } from "@services";
import { FindUsersDetailsRequest, UserDetail, UsersDetailFilter } from "@model";
import { USER_LIST } from "../app-routing.module";
import { inject } from "@angular/core";

export const UserListResolver: ResolveFn<Observable<UserDetail[]> | UserDetail[]> | any =
  (route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    router: Router,
    organiserUserService: OrganiserUsersService = inject(OrganiserUsersService),
    adminService: AdministratorsService = inject(AdministratorsService)): Observable<UserDetail[]> | UserDetail[] | any => {
    let currentPath: string | undefined = route.routeConfig?.path;
    let role = route.queryParams['role'] ? +route.queryParams['role'] : undefined;
    let text = route.queryParams['text'] ? route.queryParams['text'] : undefined;
    switch (currentPath) {
      case 'organisers/edit':
        return organiserUserService.findUsers(+route.queryParams['organiserId']);
      case 'profile':
        return organiserUserService.findUsers();
      default:
        if ((role && UsersDetailFilter.ROLES.includes(role)) || !role) {
          return adminService.findUsers(FindUsersDetailsRequest.createUsersDetailsRequest(1, { role: role, text: text }), true);
        }
        else {
          router.navigate([USER_LIST])
          return EMPTY
        }
    }
  }
